import React from "react";

const TransferSecondaryIcon = React.forwardRef(
  (
    {
      variant = "solid",              
      width,
      height,
      brandColor = "#5062F0",         
      strokeColorSolid = "#FFFFFF",   
      strokeColorOutline = "#D0D3E2", 
      strokeWidthSolid = 1.8,
      strokeWidthOutline = 1.2,
      className,
      ...props
    },
    ref
  ) => {
    const isSolid = variant === "solid";
    const w = width ?? (isSolid ? 21 : 19);
    const h = height ?? (isSolid ? 15 : 12);

    return (
      <svg
        ref={ref}
        width={w}
        height={h}
        viewBox={isSolid ? "0 0 21 15" : "0 0 19 12"}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        {isSolid && (
          <path
            d="M0 2C0 0.89543 0.895431 0 2 0H16C18.7614 0 21 2.23858 21 5V10C21 12.7614 18.7614 15 16 15H2C0.89543 15 0 14.1046 0 13V2Z"
            fill={brandColor}
          />
        )}

        <path
          d={
            isSolid
              ? "M15.3937 10.5436C15.3937 10.5436 18.8223 7.783 18.8223 6.5999M18.8223 6.5999C18.8223 5.4168 15.3937 2.65624 15.3937 2.65624M18.8223 6.5999L4.32227 6.5999C3.49384 6.5999 2.82227 7.27148 2.82227 8.0999L2.82227 12.5"
              : "M14.2175 8.54356C14.2175 8.54356 17.8223 5.783 17.8223 4.5999M17.8223 4.5999C17.8223 3.4168 14.2175 0.656237 14.2175 0.656237M17.8223 4.5999L2.5 4.5999C1.67157 4.5999 1 5.27148 1 6.0999L1 10.5"
          }
          stroke={isSolid ? strokeColorSolid : strokeColorOutline}
          strokeWidth={isSolid ? strokeWidthSolid : strokeWidthOutline}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);

export default React.memo(TransferSecondaryIcon);
